import { createSlice } from "@reduxjs/toolkit";
import { getDefaultReferralStatusFilter } from "../lib/systemData";

const defaultReferralStatusRows = getDefaultReferralStatusFilter()

const initialReferralsState = {
    currentpage: 1,
    currentpagedata: null,
    listFiltersParams: null,
    filters: defaultReferralStatusRows.length
        ? {
              status: defaultReferralStatusRows.map((o) => ({ value: o.value, label: o.label })),
          }
        : {},
    userClearedReferralFilters: false,
    pageResults: null,
    isAPracticeUsedAsFilter: null,
    snapshotData: null,
    snapshotDataVerification: null,
    orderFilters: null,
    loading: false,
    requesterId: null,
}

const referralsSlice = createSlice({
    name: 'referrals',
    initialState: initialReferralsState,
    reducers: { 
        setCurrentPage(state, data) {
            state.currentpage = data.payload
        },
        setCurrentPageData(state, data) {
            state.currentpagedata = data.payload
        },
        saveListFiltersParams(state, data) {
            state.listFiltersParams = data.payload
        },
        setFilters(state, data) {
            state.filters[data.payload.filter] = data.payload.value
        },
        setFiltersMultiple(state, data) {
            state.filters = data.payload
        },
        setUserClearedReferralFilters(state, data) {
            state.userClearedReferralFilters = data.payload
        },
        updateReferralInList(state, data) {
            const { id, status } = data.payload
            for (const pageData of [state.currentpagedata, state.snapshotData]) {
                if (!pageData?.data) {
                    continue
                }
                const row = pageData.data.find((r) => r.id === id || r.id == id)
                if (row) {
                    row.status = status
                }
            }
        },
        removeSingleFilter(state, data) {
            if (!data.payload.multiple) { // if its not for a multiple selection, simply remove
                state.filters[data.payload.filter] = null
            } else { // multiple selection!!!
                const itemIndex = state.filters[data.payload.filter].findIndex(object => {
                    return object.value == data.payload.value                  
                })

                if (itemIndex !== -1) {
                    if (state.filters[data.payload.filter].length == 1) {
                        state.filters[data.payload.filter] = null
                    } else {
                        state.filters[data.payload.filter].splice(itemIndex, 1)
                    }      
                    
                }
            }
            // state.filters[data.payload.filter] = null
        },
        clearFilters(state) {
            state.filters = {
                case_status: null,
                case_type: null,
                location: null,
                practice: null,
                year: null
            }
        },
        setPageResults(state, data) {
            state.pageResults = data.payload
        },
        setIsAPracticeUsedAsFilter(state, data) {
            state.isAPracticeUsedAsFilter = data.payload
        },
        setSnapshotData(state, data) {
            state.snapshotData = data.payload
        },
        setSnapshotDataVerification(state, data) {
            state.snapshotDataVerification = data.payload
        },
        setSnapshotDataGeneral(state, data) {
            state.snapshotDataGeneral = data.payload
        },
        setOrderFilters(state, data) {
            state.orderFilters = data.payload
        },
        setMasterLoading(state, data) {
            state.loading = data.payload
        },
        setRequesterId(state, data) {
            state.requesterId = data.payload
        }
    }
})

export const referralsActions = referralsSlice.actions

export default referralsSlice.reducer